<template>
  <base-message-page title="Questionario già compilato" message="Non è possibile apportare ulteriori modifiche." />
</template>

<script>
import BaseMessagePage from '@/components/BaseMessagePage.vue'

export default {
  components: {
    BaseMessagePage,
  },
}
</script>
